<template>
  <v-container fluid style='background-color:white'>
    <v-layout row wrap fill-height justify-center>
      <v-flex xs12 sm12 md12 lg12>
        <v-card flat>
          <br />
          <v-layout justify-center >
            <v-card-title class='headlinestyle'><strong>จัดการราคาสินค้า</strong></v-card-title>
          </v-layout>
          <!-- <v-layout row wrap justify-end>
            <v-flex xs7 sm2 md2 lg2>
              <v-btn class="mx-2 addbuttonstyle" outlined color="indigo lighten-2" @click="opengrouppricedetail('')">
                <v-icon>mdi-plus</v-icon>&nbsp;
                เพิ่มตาราง
              </v-btn>
            </v-flex>
          </v-layout>
          <br /> -->
          <br />
        <v-layout row wrap justify-center align-end>
          <v-flex xs12 sm11 md11 lg11>
             <v-layout row wrap justify-start>
              <v-flex xs12 sm6 md4 lg4 px-5>
                <p style="color:#4C4C4C; font-size:90%;"><strong>รหัสตารางราคาสินค้า</strong></p>
                <v-text-field v-model="groupprice_no_search" outlined clearable dense v-on:input="grouppricefilterfunction()" color="pink lighten-3"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4 lg4 px-5>
                <p style="color:#4C4C4C; font-size:90%;"><strong>ชื่อตารางราคาสินค้า</strong></p>
                <v-text-field v-model="name_search" outlined clearable dense v-on:input="grouppricefilterfunction()" color="pink lighten-3"></v-text-field >
              </v-flex>
                <v-layout row wrap justify-end align-center>
                  <v-flex xs6 sm3 md6 lg6 px-7>
                    <br />
                    <v-btn class="mx-2 addbuttonstyle" outlined dense color="indigo lighten-2" @click="opengrouppricedetail('')">
                      <v-icon>mdi-plus</v-icon>&nbsp;
                      เพิ่มตาราง
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-layout><br />
          <v-data-table
            :headers="headers"
            :items="grouppricedata_view"
            :items-per-page="10"
            class="elevation-3"
            :loading="loading"
            :footer-props="{
              itemsPerPageOptions: [5, 10, 20, 50, 100]
            }"
          >
          <template v-slot:body="{ items }">
                <tbody>
                  <tr
                    v-for="item in items"
                    :key="item._id"
                    style="cursor: pointer;"
                    align='center'
                  >
                  <td @click="opengrouppricedetail(item._id)">{{ item.groupprice_no }}</td>
                  <td @click="opengrouppricedetail(item._id)">{{ item.name }}</td>
                  <td>
                    <v-btn class="ma-2" outlined small fab color="pink lighten-2" @click="opengrouppricedetail(item._id)">
                      <v-icon meduim>mdi-pencil</v-icon>
                    </v-btn>
                     <v-btn class="ma-2" outlined small fab color="red" @click="deletegroupprice(item._id, item.name)">
                      <v-icon meduim>mdi-delete-forever</v-icon>
                    </v-btn>
                  </td>
                  </tr>
                </tbody>
          </template>
          </v-data-table>
          </v-flex>
        </v-layout>
        <br />
        <br />
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
import { sync } from 'vuex-pathify'
import swal from 'sweetalert'
export default {
  data: () => ({
    headers: [
      { text: 'รหัสตารางราคาสินค้า', align: 'center', sortable: false, value: 'groupprice_no' },
      { text: 'ชื่อตารางราคาสินค้า', align: 'center', sortable: false, value: 'name' },
      { text: 'แก้ไข/ลบ', value: 'action', sortable: false, align: 'center' }
    ],
    grouppricedatas: [],
    grouppricedata_view: [],
    groupprice_no_search: '',
    name_search: '',
    loading: false
  }),
  created () {
    if (this.$cookies.get('token') !== '') {
      if (this.$cookies.get('status') === 'super admin') {
        this.getdata()
      } else {
        this.$router.push('/')
      }
    } else {
      this.$router.push('/')
    }
  },

  methods: {
    async getdata () {
      try {
        this.loading = true
        let { data } = await axios.get(`${process.env.VUE_APP_API}/groupprice/get/list`, {
          headers: {
            Authorization: this.$cookies.get('token')
          }
        })
        this.grouppricedatas = data
        this.grouppricedata_view = this.grouppricedatas
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },
    opengrouppricedetail (id) {
      this.currentgrouppriceid = id || ''
      let urlstr = id ? `/grouppricedetail/${id}` : `/grouppricedetail`
      this.$router.push(urlstr)
    },
    async deletegroupprice (id, name) {
      try {
        await swal({
          title: `คุณแน่ใจที่จะลบตาราง ${name} ?`,
          icon: 'warning',
          buttons: ['ยกเลิก', 'ลบ'],
          dangerMode: true
        }).then(async (willDelete) => {
          if (willDelete) {
            let { data } = await axios.delete(`${process.env.VUE_APP_API}/groupprice/delete/${id}`, {
              headers: {
                Authorization: this.$cookies.get('token')
              }
            })
            if (data) {
              await swal(`ตาราง ${name} ถูกลบแล้ว!`, {
                icon: 'success',
                buttons: 'ตกลง'
              })
              this.getdata()
            }
          }
        })
      } catch (error) {
        await swal({
          title: `ระบบผิดพลาด`,
          text: 'กรุณาลองอีกครั้งในภายหลัง',
          icon: 'warning',
          buttons: 'ตกลง',
          dangerMode: true
        })
      }
    },
    grouppricefilterfunction () {
      this.grouppricedata_view = this.grouppricedatas.filter(groupprice => {
        let condition = [
          this.groupprice_no_search ? (groupprice.groupprice_no.toLowerCase()).includes((this.groupprice_no_search).toLowerCase()) : true,
          this.name_search ? (groupprice.name.toLowerCase()).includes((this.name_search).toLowerCase()) : true
        ]
        return condition.every(con => con)
      })
    }
  },
  computed: {
    currentgrouppriceid: sync('currentgrouppriceid')
  }
}
</script>

<style scoped >
.container {
  margin: 5px;
}
.container .con {
  margin: 0px;
}
.headlinestyle {
  font-family: 'Kanit';
  font-style: normal;
  font-weight: normal;
  font-size: 30px;
  line-height: 54px;
  color: #000000;
}
.v-data-table th {
  height: 60px !important;
}
.v-data-table {
  font-family: 'Kanit';
}
.addbuttonstyle {
  font-family: 'Kanit';
  font-weight: bold;
}
.v-text-field {
  font-family: 'Kanit';
}
</style>
